// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SecurityScanOutlinedSvg from "@fishx/icons-svg/es/asn/SecurityScanOutlined";
import FishxIcon from '../components/FishxIcon';

var SecurityScanOutlined = function SecurityScanOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SecurityScanOutlinedSvg
  }));
};

SecurityScanOutlined.displayName = 'SecurityScanOutlined';
export default React.forwardRef(SecurityScanOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SecurityScanOutlined.js
// module id = 4082
// module chunks = 0